import React, { useMemo } from 'react';
import { DateUtils } from '@vectord/utils';
import { Tappable } from '@vectord/components';
import classNames from 'classnames';

import generateTimeStringFromMinutes from 'utils/generateTimeStringFromMinutes';
import styles from './ContestReattempt.module.scss';

function ContestReattempt({ interviewbitTest, isClassTemplate }) {
  const {
    test_id: testId,
    duration,
    start_time: startTime,
    end_time: endTime,
    title,
    offset,
    window,
    meta,
  } = interviewbitTest || {};
  const {
    window: metaWindow,
    title: metaTitle,
    offset: metaOffset,
  } = meta || {};

  const formattedWindow = useMemo(
    () => generateTimeStringFromMinutes(window || metaWindow || 0),
    [metaWindow, window]
  );
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <span className="dark">{title || metaTitle}</span>
        <span className={classNames(styles.neutralScale7, 'h5')}>{testId}</span>
      </div>
      <div className={styles.body}>
        {!isClassTemplate && (
          <div className="m-b-xxs">
            <span className={styles.neutralScale7}>Duration: </span>
            <span className="dark">{duration} Mins</span>
          </div>
        )}
        <div className="m-b-xxs">
          <span className={styles.neutralScale7}>Window: </span>
          <span className="dark">{formattedWindow}</span>
        </div>
        {isClassTemplate && (
          <div className="m-b-xxs">
            <span className={styles.neutralScale7}>Offset: </span>
            <span className="dark">{offset || metaOffset || 0}</span>
          </div>
        )}
        {!isClassTemplate && (
          <>
            <div className="m-b-xxs">
              <span className={styles.neutralScale7}>Start Date & Time: </span>
              <span className="dark">{DateUtils.toDateDayTime(startTime)}</span>
            </div>
            <div className="m-b-xxs">
              <span className={styles.neutralScale7}>End Date & Time: : </span>
              <span className="dark">{DateUtils.toDateDayTime(endTime)}</span>
            </div>
          </>
        )}
        <Tappable
          className="link bold"
          href={`/hire/test/${testId}`}
          noHighlight
          target="_blank"
        >
          + Add Questions
        </Tappable>
      </div>
    </div>
  );
}

export default ContestReattempt;
